/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>
/// <reference path="IndicatorSelectionButtonsView.js"/>
/// <reference path="IndicatorSelectionTreeView.js"/>
/// <reference path="IndicatorSelectionCheckboxView.js"/>
/// <reference path="~/js/profileSelection/IndicatorSelectionCreateProfileView.js"/>
/// <reference path="~/js/shared/ArraySerializationRouterBase.js"/>

(function(_) {
  var ns;

  ns = window.nspace("ccc.profileSelection");

  /**
   * The router for our app.
   */
  ns.IndicatorSelectionRouter = window.ccc.shared.ArraySerializationRouterBase.extend(
    {
      initialize: function() {
        _.bindAll(this);
      },

      routes: {
        "": "initializeViews",
        ":selectedLocationType": "initializeViews",
        ":selectedLocationType/:selectedLocation": "initializeViews",
        ":selectedLocationType/:selectedLocation/:selectedCategories":
          "initializeViews",
        ":selectedLocationType/:selectedLocation/:selectedCategories/:selectedIndicators":
          "initializeViews"
      },

      /**
       * Receives and routes our route data.
       */
      initializeViews: function(
        selectedLocationType,
        selectedLocation,
        selectedCategories,
        selectedIndicators
      ) {
        // This method will only ever be invoked a single time, so use
        // it to initialize the model/view classes and trigger the initial rendering
        this.model = new ns.IndicatorSelectionModel({
          locationType: selectedLocationType,
          location: selectedLocation,
          categories: this.getArrayFromModelProperty(selectedCategories),
          indicators: this.getArrayFromModelProperty(selectedIndicators)
        });

        // Listen for changes to the model and update our URL
        this.model.on("change", this.updateUrl);

        // Apply the model to the views
        this.selectorsView = new ns.IndicatorSelectionButtonsView({
          model: this.model,
          el: ".location-lists-container"
        });
        this.tableView = new ns.IndicatorSelectionTreeView({
          model: this.model,
          el: ".indicator-container"
        });
        this.checkboxView = new ns.IndicatorSelectionCheckboxView({
          model: this.model,
          el: ".indicator-container"
        });
        this.customizeProfileView = new ns.IndicatorSelectionCreateProfileView({
          model: this.model,
          el: "a.customize-profile"
        });

        // Trigger a change notification on the model now that all of the selectors have finished initializing
        // so that other components can update themselves to reflect the current app state
        this.model.trigger("change");
      },

      /**
       * Writes our model's state to the URL.
       */
      updateUrl: function() {
        var urlParts;

        urlParts = [
          this.model.get("locationType") || "n",
          this.model.get("location") || "n",
          this.getStringFromArrayProperty(this.model.get("categories")),
          this.getStringFromArrayProperty(this.model.get("indicators"))
        ];

        this.navigate(urlParts.join("/"), { replace: true });
      }
    }
  );
})(_);
